import React from 'react';
import Slide, { ISlide } from '../../../../core/Slide';
import Penguin from '../../characters/Penguin';
import { DialogueData } from '../../../../general/Dialogue';
import { CharacterDialogue } from '../../../../general/Character';
import useFooterButtonRenderer from '../../../../misc/FooterButtonRenderer';
import { t } from 'ttag';
import { FestiveData } from '../..';

const PenguinIntro: React.FC<ISlide<FestiveData>> = ({ defaultHeader, nextSlide, data }) => {
    const [footer, buttonRenderer] = useFooterButtonRenderer();

    const dialogue: DialogueData[] = [
        {
            character: Penguin,
            text: t`Hi, I am Penguin and welcome to the North Pole! I am looking for someone to help me with organising festive gifts this year. Can you help?`,
            buttonText: t`Let's go!`,
        },
        {
            character: Penguin,
            text: t`Perfect! Before we get going, I am going to need your nickname.`,
            buttonText: t`My nickname is...`,
            buttonAction: nextSlide,
        },
    ];

    return (
        <Slide header={defaultHeader} footer={footer}>
            <CharacterDialogue dialogue={dialogue} buttonHandler={buttonRenderer} />
        </Slide>
    );
};

export default PenguinIntro;
